import { useDispatch } from 'react-redux';

import { TDispatch } from 'shared/types/redux';

export const useAppDispatch: () => TDispatch = useDispatch;
